<template>
  <div class="chat-message" :class="{ mine }">
    <div class="chat-message__datetime">
      <span class="chat-message__datetime-date">{{ date.toLocaleDateString().replace(/\//g, '.') }}</span>
      <span class="chat-message__datetime-time">{{ date.toLocaleTimeString(undefined, { hour12: false }).substr(0, 5).replace(/\:$/g, '') }}</span>
    </div>

    <div class="chat-message__body">
      <div class="chat-message__username">{{ mine ? $tCooperation('You') : username }}</div>
      <div class="chat-message__content">{{ content }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'mine', 'date', 'content', 'username' ]
  };
</script>
